import React, { useState, useEffect } from "react";
import { Redirect } from "react-router-dom";
import axios from "axios";
import ReferralTable from "../components/ReferralTable";
import { connect } from "react-redux";
import ResponsiveDrawer from "../components/ResponsiveDrawer";
import ProgressBar from "../components/ProgressBar";
import { Box, Grid, Stack, Typography, Button } from "@mui/material";
import { makeStyles } from "@material-ui/core";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

const useStyles = makeStyles((theme) => {
  return {
    root: {
      minHeight: "100vh",
      backgroundColor: "#F7F8FA",
    },
    toolbar: {
      height: "64px",
    },
    stack: {
      backgroundColor: "#ffff",
      borderRadius: "12px",
      padding: "12px",
      boxShadow: "0px 2px 6px #0000000a",
      height: "180px",
      [theme.breakpoints.down("md")]: {
        height: "230px",
      },
    },
    secondStack: {
      backgroundColor: "#ffff",
      borderRadius: "12px",
      padding: "12px",
      boxShadow: "0px 2px 6px #0000000a",
      height: "180px",
      [theme.breakpoints.down("md")]: {
        height: "230px",
      },
      [theme.breakpoints.down("sm")]: {
        height: "320px",
      },
    },
    button: {
      textTransform: "none",
    },
    balance: {
      fontSize: "40px !important",
      fontWeight: "bold !important",
      color: "#006EFF",
    },
  };
});

function Referrals(props) {
  const classes = useStyles();

  const [loading, setLoading] = useState(true);
  const [balance, setBalance] = useState(0);
  const [referralEarnings, setReferralEarnings] = useState();
  // console.log(">>referralEarnings", referralEarnings.length);

  let tokenStorage = null;

  useEffect(() => {
    if (props.token) {
      tokenStorage = props.token;
    }
    if (isLoggedIn) {
      reqReferrals();
    }
  }, []);

  const reqReferrals = async () => {
    await axios
      .get(
        `https://bck-aix-en-provence.carloapp.com/api/business/referral_report`,
        {
          method: "GET",
          headers: {
            Version: "4.0",
            Authorization: `Bearer ${tokenStorage}`,
          },
        }
      )
      .then((res) => {
        // console.log("res", res);
        setBalance(res.data.data.balance);
        setReferralEarnings(res.data.data.details);
        setLoading(false);
      });
  };

  const handleCopy = () => {
    const referralCode = localStorage.getItem("refferalCode");
    navigator.clipboard.writeText(referralCode);
  };

  const handleShareByEmail = () => {
    const subject = "Téléchargez l'application Carlo !";
    const referralCode = localStorage.getItem("refferalCode");
    const body = `Cliquez sur ce lien pour télécharger Carlo: http://onelink.to/ec8jw4 et n'hésitez pas à m'indiquer comme parrain en rajoutant mon code parrainage : ${referralCode} `;

    const mailtoLink = `mailto:?subject=${encodeURIComponent(
      subject
    )}&body=${encodeURIComponent(body)}`;
    window.location.href = mailtoLink;
  };

  // Redirect user if not logged in
  let isLoggedIn = localStorage.getItem("token");
  if (isLoggedIn) {
    tokenStorage = isLoggedIn.slice(1, isLoggedIn.length - 1);
  }
  // console.log(">>local storage", isLoggedIn);
  if (!props.token && !isLoggedIn) {
    return <Redirect to="/" />;
  }
  if (!props.token && isLoggedIn) {
    props.onSetToken(tokenStorage);
  }

  return (
    <Box sx={{ display: "flex" }}>
      <ResponsiveDrawer />
      <Box className={classes.root} sx={{ flexGrow: 1, p: 3 }}>
        <div className={classes.toolbar}></div>

        {/* Start of component */}
        {/* ternary condition to show loading while waiting for api response */}
        {loading ? (
          <ProgressBar />
        ) : (
          <Grid>
            <Grid container spacing={4}>
              {/* <Grid item xs={12} md={5}> */}
              {/* <h3>Gains Parrainage</h3>
                <Stack
                  direction="column"
                  className={classes.stack}
                  spacing={2}
                  pt={8}
                >
                  <Typography variant="subtitle1">
                    Gains parrainage à recevoir
                  </Typography>
                  <Typography className={classes.balance}>
                    {balance} €
                  </Typography>
                </Stack> */}
              {/* </Grid> */}

              <Grid item xs={12} md={7}>
                <h3>Programme de parrainage</h3>
                <Stack
                  direction="column"
                  className={classes.secondStack}
                  spacing={2}
                >
                  <Typography variant="subtitle1">
                    Lorsque vous parrainez un utilisateur, vous recevez 2% de
                    cashback sur toutes leurs transactions effectuées avec Carlo
                  </Typography>
                  <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
                    Partager votre code parrainage
                  </Typography>

                  <Stack direction="row" spacing={2}>
                    <Button
                      variant="outlined"
                      endIcon={<ContentCopyIcon />}
                      sx={{ width: "130%" }}
                      style={{ justifyContent: "space-between" }}
                      onClick={handleCopy}
                    >
                      <span style={{ fontWeight: "bold" }}>
                        {localStorage.getItem("refferalCode")}
                      </span>
                    </Button>
                    <Button
                      variant="contained"
                      sx={{ width: "70%" }}
                      onClick={handleShareByEmail}
                    >
                      Partager par mail
                    </Button>
                  </Stack>
                </Stack>
              </Grid>
            </Grid>

            {referralEarnings.length ? (
              <ReferralTable referralEarnings={referralEarnings} />
            ) : (
              <Stack mt={4}>
                <h3>
                  Vous n'avez pas reçu de gains parrainage, parrainez vos
                  clients pour recevoir 2% de tous leurs achats Carlo.
                </h3>
              </Stack>
            )}
          </Grid>
        )}
      </Box>
    </Box>
  );
}

function mapDispatchToProps(dispatch) {
  return {
    onSetToken: function (token) {
      dispatch({ type: "setToken", token: token });
    },
  };
}

function mapStateToProps(state) {
  return { token: state.token };
}

export default connect(mapStateToProps, mapDispatchToProps)(Referrals);
